import userMapModel from '../../../../models/user/user-map.model';
import ViewBase from '../../../view-base.view';
import siteModel from '../../../../models/site/site.model';

export default function UserDetailsCountryMapCard() {
  ViewBase.call(this);
  let _userMapInfo = [];
  let _managedSite = [];
  let managedSiteGroupTxt = [];
  let locationTxt = [];

  const _loadStoreGroupList = () => {
    let managedSiteGroupCodes = getUserMapData('SITEGROUP').map(sg => sg.mapData);

    // Get site group names by codes
    siteModel.getSiteGroupsBySiteGroupCodes(managedSiteGroupCodes)
      .then((result) => {
        let managedSiteGroups = result ?? [];
        managedSiteGroupTxt = managedSiteGroups.map(sg => sg.name);
      })
      .catch((error) => {
        this.handleError(error)
      });
  }

  const _getLocations = (country) => {
    return siteModel.getByType({ type: 'location', countryCode: country })
      .then((result) => {
        let locArr = getUserMapData('REGION');
        locationTxt = [];

        locArr.forEach(function (item) {
          let det = result.filter(x => x.code == item.mapData);
          locationTxt.push(det[0].name);

        });
      })
      .catch((error) => {
        this.handleError(error);
      });
  }

  const setUserMap = (userId, country) => {
    if (country.code && country.code != '') {
      userMapModel.getByUser(
        (result) => {
          _userMapInfo = result;
          _loadStoreGroupList();
          _getLocations(country.code);
        }, (error) => {
          this.handleError(error);
        }, country.code, 'all', userId);
    }

  }

  const getUserMapData = (mapType) => {
    var data = _userMapInfo.filter(f => f.mapType === mapType);
    return data;
  }

  const setSite = (userId, country) => {
    siteModel.getManagedSiteByCountryUser(country.code, userId)
      .then((result) => {
        if (result != null) {
          result.forEach(function (item) {
            _managedSite.push(item.siteName);
          });
        }
      })
      .catch((error) => {
        this.handleError(error);
      });
  }

  const renderLabel = (label, value) => {
    return [m('label.col-sm-4 .form-label', label), m('span.col-sm-8 .highlight-gray font-weight-bold', value)];
  }

  const renderList = (label, listValue) => {
    return [
      m('label.col-sm-3 .form-label', label),
      m('div.col-sm-9 .highlight-gray font-weight-bold border', { style: "height:100px;overflow:auto;padding:5px" }, listValue.map(v => (m('span.highlight-gray font-weight-bold', { "style": "border:1px solid grey;border-radius:10px;padding:2px;float:left;margin-right:2px;margin-bottom:2px" }, `${v}`))))
    ];
  }

  return {
    oninit: ({ attrs }) => {
      setUserMap(attrs.userId, attrs.country);
      setSite(attrs.userId, attrs.country);
    },
    view: ({ attrs }) => {
      return [
        m("div", { "class": "card mb-3 searchbox no-leftradius" },
          m("div", { "class": "card-body py-4" },
            m('.row .justify-content-center',
              m('.col-md-12',
                m('form',
                  m('.row .mb-3 small', m('h4', attrs.country?.name)),
                  m('.row md-2', [
                    m('.col-md-6', renderLabel(this.getText("LT00000060", "User Role"), getUserMapData('USERROLE')[0]?.mapData)),
                    m('.col-md-6', ''),
                  ]
                  ),
                  m('.row md-2', [
                    m('.col-md-6', renderLabel(this.getText("LT00000224", "Admin"), getUserMapData('ADMIN_YN')[0]?.mapData == "Y" ? "Yes" : "No")),
                    m('.col-md-6', renderLabel(this.getText("LT00000264", "Require Approval"), getUserMapData('REQUIRED_APPROVAL')[0]?.mapData == "N" ? "No" : "Yes")),
                  ]
                  ),
                  m('.row md-12',
                    m('.row.col-md-12', renderList(this.getText("LT00000239", "BU"), getUserMapData('BU').map(m => m.mapData))),
                  ),
                  m('.row md-12',
                    m('.row.col-md-12', renderList(this.getText("LT00000265", "RETAILDIV"), getUserMapData('RETAILDIV').map(m => m.mapData))),
                  ),
                  m('.row md-12',
                    m('.row.col-md-12', renderList(this.getText("LT00000266", "GSCMDIV"), getUserMapData('GSCMDIV').map(m => m.mapData))),
                  ),
                  m('.row md-12',
                    m('.row md-12', renderList(this.getText("LT00000229", "Managed Site"), _managedSite)),
                  ),
                  m('.row md-12',
                    m('.row md-12', renderList(this.getText("LT00000230", "Managed Site Group"), managedSiteGroupTxt)),
                  ),
                  m('.row md-12',
                    m('.row md-12', renderList(this.getText("LT00000231", "Managed Location"), locationTxt)),
                  )
                )
              )
            )
          )
        ),
        this.getBaseViews()
      ];
    }
  }
}
